import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getUserProfile, updateUserProfile, updateUserPassword, deleteUserAccount } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import './profile.css';

function UserProfile() {
  const  logout  = useAuth();
  const [profile, setProfile] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profileData = await getUserProfile();
        setProfile(profileData);
        setUsername(profileData.username);
        setEmail(profileData.email);
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
        setMessage('Failed to load profile.');
      }
    };

    fetchProfile();
  }, []);

  const handleUpdateProfile = async () => {
    try {
      await updateUserProfile({ username, email });
      setEditMode(false);
      setMessage('Profile updated successfully.');
      // Update the context if necessary
      // Assuming the context updates on login, for simplicity, we won't update it here.
      // You might need to dispatch an action to update the context with the new username/email.
      const updatedProfile = await getUserProfile();
      setProfile(updatedProfile);
    } catch (error) {
      console.error('Failed to update profile:', error);
      setMessage('Failed to update profile.');
    }
  };

  const handleChangePassword = async () => {
    try {
      await updateUserPassword(newPassword);
      setMessage('Password updated successfully.');
      setNewPassword('');
    } catch (error) {
      console.error('Failed to update password:', error);
      setMessage('Failed to update password.');
    }
  };

  const handleDeleteAccount = async () => {
    if (window.confirm('Are you sure you want to delete your account? This action cannot be undone.')) {
      try {
        await deleteUserAccount();
        setMessage('Account deleted successfully.');
        logout(); // Clear context
        navigate('/login'); // Redirect to login
      } catch (error) {
        console.error('Failed to delete account:', error);
        setMessage('Failed to delete account.');
      }
    }
  };

  if (!profile) {
    return <div>Loading profile...</div>;
  }

  return (
        <div className="user-profile-container">
            <h2>User Profile</h2>

            {message && <div className={`message ${message.includes('success') ? 'success' : 'error'}`}>{message}</div>}

            {editMode ? (
                <div>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className="edit-profile-actions">
                        <button onClick={handleUpdateProfile}>Save Changes</button>
                        <button onClick={() => setEditMode(false)} className="cancel-button">Cancel</button>
                    </div>
                </div>
            ) : (
                <div>
                    <p><strong>Username:</strong> {profile.username}</p>
                    <p><strong>Email:</strong> {profile.email}</p>
                    <button onClick={() => setEditMode(true)}>Edit Profile</button>
                </div>
            )}

            <div>
                <h3>Change Password</h3>
                <input
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <button onClick={handleChangePassword}>Change Password</button>
            </div>

            <div>
                <h3>Delete Account</h3>
                <button onClick={handleDeleteAccount} className="delete-button">Delete Account</button>
            </div>
        </div>
    );
}

export default UserProfile;
